import React from 'react'
import { Page } from '@/payload-types'
import { HeroBlock } from '@/components'

interface PageMainProps {
  page: Page
}

function PageList({ page }: Readonly<PageMainProps>) {
  return (
    <>
      <HeroBlock title={page.title} lead={page.lead} blockType={'hero'} />
      <section>Content</section>
    </>
  )
}

export { PageList }
